import { useState, useEffect } from 'react';
import { Header } from '../components/Header';
import { HeroSection } from '../components/HeroSection';
import { CategorySection } from '../components/CategorySection';
import { ProductSection } from '../components/ProductSection';
import { BannerSection } from '../components/BannerSection';
import { FeaturesSection } from '../components/FeaturesSection';
import { Footer } from '../components/Footer';

export function HomePage() {
  const [activeCategory, setActiveCategory] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    const catParam = params.get('cat');
    if (catParam) return catParam;
    const saved = localStorage.getItem('selectedCategory');
    if (saved) {
      localStorage.removeItem('selectedCategory');
      return saved;
    }
    return 'all';
  });

  useEffect(() => {
    if (activeCategory !== 'all') {
      setTimeout(() => {
        const el = document.getElementById('products-section');
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 300);
    }
  }, []);

  useEffect(() => {
    const handleCategoryChange = () => {
      const cat = localStorage.getItem('selectedCategory') || 'all';
      setActiveCategory(cat);
      localStorage.removeItem('selectedCategory');
    };
    window.addEventListener('categoryChange', handleCategoryChange);
    return () => window.removeEventListener('categoryChange', handleCategoryChange);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header onCategoryChange={setActiveCategory} initialCategory={activeCategory} />
      <main>
        <HeroSection />
        <CategorySection />
        <div id="products-section">
          <ProductSection activeCategory={activeCategory} />
        </div>
        <BannerSection />
        <FeaturesSection />
      </main>
      <Footer />
    </div>
  );
}
